module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/en_tohoku-5071fc9b73c8c474122e812d41067e5d.jpg";